<template>
  <iColumn
    :width="fullTextOptionsAttributes.width"
    height="hug"
    gap="small"
    data-test="subscription-legal-footer"
  >
    <iText
      v-bind="textOnlyAttributes"
      :style-overrides="textOnlyAttributes.textStyleOverrides"
    >
      {{ autoRenewText }}
    </iText>
    <iRow
      width="hug"
      height="hug"
      gap="standard"
    >
      <iLink
        v-for="link in links"
        :key="link.key"
        :href="editMode ? undefined : link.href"
        target="_blank"
        :data-test="`subscription-legal-${link.key}`"
      >
        {{ link.label }}
      </iLink>
    </iRow>
  </iColumn>
</template>

<script>
import TextElement from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { links as linkNames } from "%/dynamic-component-editor/enums/link-enums";
import {
  AUTO_RENEW_TEXT,
  buildLegalLinks,
} from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

// Auto-renew line + Terms / Privacy links; every Plan Sheet must carry one to publish.
export default {
  name: "SubscriptionLegalFooter",
  extends: TextElement,
  elementPanelSettings: {
    displayName: "Subscription Legal Footer",
    displayIcon: "text-alt",
    elementType: "element",
    tags: ["payments", "legal", "terms", "privacy", "auto-renew"],
  },
  computed: {
    isEditable() {
      return false;
    },
    autoRenewText() {
      return AUTO_RENEW_TEXT;
    },
    links() {
      return buildLegalLinks(useGeneralStore().getLink(linkNames.web));
    },
  },
};
</script>
